import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import LanguageWriteDTO from '../../../../../../types/language/LanguageWriteDTO';
import { LanguageService } from '../../../../services/language.service';

@Component({
    selector: 'app-update-language-dialog',
    templateUrl: './update-language-dialog.component.html',
    styleUrls: ['./update-language-dialog.component.scss'],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
    ]
})
export class UpdateLanguageDialogComponent {
    @Input() visible: boolean = false;
    @Input() language: LanguageWriteDTO = new LanguageWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() languageUpdated: EventEmitter<LanguageWriteDTO> = new EventEmitter<LanguageWriteDTO>();

    constructor(private languageService: LanguageService,
                private messageService: MessageService) {}

    public loading = false;

    get saveDisabled(): boolean {
        return !this.language?.name || !this.language?.localeKey;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public updateLanguage() {

        this.loading = true;

        this.languageService.updateLanguage(this.language).then(() => {
            this.languageUpdated.emit(this.language);
            this.close();
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        }).finally(() => {
            this.loading = false;
        });
    }
}
